module.exports = __webpack_public_path__ + "static/media/dropdown3.f9a0914e.svg";